import { Api } from "telegram";

export default async function replaceSnippets(text, snippets, item, client) {
  await client.connect();
  const type = item.peerType;
  let formattedText = text;

  for (let snippet of snippets) {
    let result;
    switch (snippet) {
      case "name":
        if (type === "channel" || type === "chat") {
          formattedText = text.replace("{{name}}", "@everyone");
        }
        if (type === "user") {
          result = await client.invoke(
            new Api.users.GetFullUser({
              id: item.peerId,
            }),
          );
          formattedText = text.replace(
            "{{name}}",
            !!result.users[0].username
              ? `@${result.users[0].username}`
              : result.users[0].firstName,
          );
        }
        break;
      default:
        break;
    }
  }
  return formattedText;
}
